import React, { useState } from 'react';
import axios from 'axios';
import './../Styles/CreateGoal.css';  // Adjust the path according to your folder structure

const apiUrl = process.env.REACT_APP_API_URL ;

const CreateGoal = ({ onClose, onGoalCreated }) => {
    const [goal, setGoal] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleCreateGoal = async () => {
        if (!goal.trim()) {
            setStatusMessage('Goal description cannot be empty');
            setStatusType('warning');
            return;
        }

        setIsSubmitting(true);
        setStatusMessage('');

        try {
            const response = await axios.post(`${apiUrl}/api/create-goal`, { goal_description: goal.trim() });
            setStatusMessage('Goal created successfully!');
            setStatusType('success');
            console.log('Goal creation response:', response);

            if (onGoalCreated) {
                onGoalCreated();
            }

            setTimeout(() => {
                onClose();
            }, 2000);
        } catch (error) {
            setIsSubmitting(false);
            console.error('Error creating goal:', error);
            if (error.response && error.response.status === 409) {
                setStatusMessage('Goal already exists');
                setStatusType('error');
            } else {
                setStatusMessage('Error creating goal. Please try again.');
                setStatusType('error');
            }
        }
    };
    
    return (
        <div className="pms-overlay modal-overlay">
            <div className="pms-modal modal-content" style={{ padding: '32px', maxWidth: '500px' }}>
                <h2 style={{ marginBottom: '16px', color: '#000000' }}>Create Goal</h2>
                
                {statusMessage && (
                    <div
                        className={`create-goal-status ${statusType}`}
                        style={{
                            marginBottom: '16px',
                            padding: '10px 14px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: statusType === 'success' ? '#dcfce7' : statusType === 'warning' ? '#fef3c7' : '#fee2e2',
                            color: statusType === 'success' ? '#15803d' : statusType === 'warning' ? '#b45309' : '#b91c1c',
                            border: `1px solid ${statusType === 'success' ? '#86efac' : statusType === 'warning' ? '#fde68a' : '#fca5a5'}`
                        }}
                    >
                        {statusType === 'success' ? '✓ ' : statusType === 'warning' ? '⚠️ ' : '✕ '}
                        {statusMessage}
                    </div>
                )}

                <textarea
                    className="pms-input"
                    style={{ minHeight: '100px', marginBottom: '16px' }}
                    value={goal}
                    onChange={(e) => {
                        setGoal(e.target.value);
                        if (statusType !== 'success') {
                            setStatusMessage('');
                        }
                    }}
                    placeholder="Enter goal details"
                    disabled={isSubmitting || statusType === 'success'}
                />
                
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button className="create-goal-btn-cancel" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                    <button className="create-goal-btn-submit" onClick={handleCreateGoal} disabled={isSubmitting || statusType === 'success'}>
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateGoal;
